import { IContactsItem, IpaginatedContacts } from '../models'

export enum ContactsActionTypes {
  SEARCH_CONTACTS = 'contacts/search',
  SEARCHING_CONTACTS = 'contacts/searching',
  FOUND_CONTACTS = 'contacts/found',
  SEARCHING_CONTACTS_FAILED = 'contacts/searching_failed',

  LOAD_CONTACTS = 'contacts/load',
  LOADING_CONTACTS = 'contacts/loading',
  LOADED_CONTACTS = 'contacts/loaded',
  LOADING_CONTACTS_FAILED = 'contacts/loading_failed',

  ADD_CONTACTS = 'contacts/add',
  ADDING_CONTACTS = 'contacts/adding',
  ADDED_CONTACTS = 'contacts/added',
  ADDING_CONTACTS_FAILED = 'contacts/adding_failed',

  REMOVE_CONTACT = 'contacts/remove',
  REMOVING_CONTACT = 'contacts/removing',
  REMOVED_CONTACT = 'contacts/removed',
  REMOVING_CONTACT_FAILED = 'contacts/removing_failed',

  SOFT_REMOVE_CONTACTS = 'contacts/soft_remove',
  SOFT_REMOVING_CONTACTS = 'contacts/soft_removing',
  SOFT_REMOVED_CONTACTS = 'contacts/soft_removed',
  SOFT_REMOVING_CONTACTS_FAILED = 'contacts/soft_removing_failed',

  EDIT_CONTACTS = 'contacts/edit',
  EDITING_CONTACTS = 'contacts/editing',
  EDITED_CONTACTS = 'contacts/edited',
  EDITING_CONTACTS_FAILED = 'contacts/editing_failed',

  VIEW_CONTACTS = 'contacts/view',
  VIEWING_CONTACTS = 'contacts/viewing',
  VIEWED_CONTACTS = 'contacts/viewed',
  VIEWING_CONTACTS_FAILED = 'contacts/viewing_failed',
}

export function searchContacts(searchOptions: TSearchOptions | string, keep?: boolean): ISearchContactsAction {
  return {
    type: ContactsActionTypes.SEARCH_CONTACTS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingContacts(): ISearchingContactsAction {
  return {
    type: ContactsActionTypes.SEARCHING_CONTACTS,
  }
}

export function foundContacts(contacts: IpaginatedContacts, keep?: boolean): IFoundContactsAction {
  return {
    type: ContactsActionTypes.FOUND_CONTACTS,
    keep: keep,
    payload: {
      contacts,
    },
  }
}

export function searchingContactsFailed(): ISearchingContactsFailedAction {
  return {
    type: ContactsActionTypes.SEARCHING_CONTACTS_FAILED,
  }
}

export function loadContacts(loadOptions: TSearchOptions): ILoadContactsAction {
  return {
    type: ContactsActionTypes.LOAD_CONTACTS,
    loadOptions: loadOptions,
  }
}

export function loadingContacts(): ILoadingContactsAction {
  return {
    type: ContactsActionTypes.LOADING_CONTACTS,
  }
}

export function loadedContacts(contacts: IpaginatedContacts): ILoadedContactsAction {
  return {
    type: ContactsActionTypes.LOADED_CONTACTS,
    payload: {
      contacts,
    },
  }
}

export function loadingContactsFailed(): ILoadingContactsFailedAction {
  return {
    type: ContactsActionTypes.LOADING_CONTACTS_FAILED,
  }
}

export function addContacts(contact: IContactsItem): IAddContactsAction {
  return {
    type: ContactsActionTypes.ADD_CONTACTS,
    payload: contact,
  }
}

export function addingContacts(): IAddingContactsAction {
  return {
    type: ContactsActionTypes.ADDING_CONTACTS,
  }
}

export function addedContacts(contacts: IpaginatedContacts): IAddedContactsAction {
  return {
    type: ContactsActionTypes.ADDED_CONTACTS,
    payload: {
      contacts,
    },
  }
}

export function addingContactsFailed(errData: { data: { message: string; field?: string }; status: number }): IAddingContactsFailedAction {
  return {
    type: ContactsActionTypes.ADDING_CONTACTS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeContact(contact: IContactsItem): IRemoveContactAction {
  return {
    type: ContactsActionTypes.REMOVE_CONTACT,
    payload: contact,
  }
}

export function removingContact(): IRemovingContactAction {
  return {
    type: ContactsActionTypes.REMOVING_CONTACT,
  }
}

export function removedContact(): IRemovedContactAction {
  return {
    type: ContactsActionTypes.REMOVED_CONTACT,
  }
}

export function removingContactFailed(): IRemovingContactFailedAction {
  return {
    type: ContactsActionTypes.REMOVING_CONTACT_FAILED,
  }
}

export function softRemoveContacts(contact: IContactsItem): ISoftRemoveContactsAction {
  return {
    type: ContactsActionTypes.SOFT_REMOVE_CONTACTS,
    payload: contact,
  }
}

export function softRemovingContacts(): ISoftRemovingContactsAction {
  return {
    type: ContactsActionTypes.SOFT_REMOVING_CONTACTS,
  }
}

export function softRemovedContacts(contact: IContactsItem): ISoftRemovedContactsAction {
  return {
    type: ContactsActionTypes.SOFT_REMOVED_CONTACTS,
    payload: contact,
  }
}

export function softRemovingContactsFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingContactsFailedAction {
  return {
    type: ContactsActionTypes.SOFT_REMOVING_CONTACTS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editContacts(contact: IContactsItem): IEditContactsAction {
  return {
    type: ContactsActionTypes.EDIT_CONTACTS,
    payload: contact,
  }
}

export function editingContacts(): IEditingContactsAction {
  return {
    type: ContactsActionTypes.EDITING_CONTACTS,
  }
}

export function editedContacts(contacts: IContactsItem): IEditedContactsAction {
  return {
    type: ContactsActionTypes.EDITED_CONTACTS,
    payload: contacts,
  }
}

export function editingContactsFailed(errData: { data: { message: string; field?: string }; status: number }): IEditingContactsFailedAction {
  return {
    type: ContactsActionTypes.EDITING_CONTACTS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewContacts(contact: IContactsItem): IViewContactsAction {
  return {
    type: ContactsActionTypes.VIEW_CONTACTS,
    payload: contact,
  }
}

export function viewingContacts(): IViewingContactsAction {
  return {
    type: ContactsActionTypes.VIEWING_CONTACTS,
  }
}

export function viewedContacts(contacts: IContactsItem): IViewedContactsAction {
  return {
    type: ContactsActionTypes.VIEWED_CONTACTS,
    payload: contacts,
  }
}

export function viewingContactsFailed(): IViewingContactsFailedAction {
  return {
    type: ContactsActionTypes.VIEWING_CONTACTS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchContactsAction {
  type: ContactsActionTypes.SEARCH_CONTACTS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingContactsAction {
  type: ContactsActionTypes.SEARCHING_CONTACTS
}

export interface IFoundContactsAction {
  type: ContactsActionTypes.FOUND_CONTACTS
  keep?: boolean
  payload: {
    contacts: IpaginatedContacts
  }
}

export interface ISearchingContactsFailedAction {
  type: ContactsActionTypes.SEARCHING_CONTACTS_FAILED
}

export interface ILoadContactsAction {
  type: ContactsActionTypes.LOAD_CONTACTS
  loadOptions: TSearchOptions
}

export interface ILoadingContactsAction {
  type: ContactsActionTypes.LOADING_CONTACTS
}

export interface ILoadedContactsAction {
  type: ContactsActionTypes.LOADED_CONTACTS
  payload: {
    contacts: IpaginatedContacts
  }
}

export interface ILoadingContactsFailedAction {
  type: ContactsActionTypes.LOADING_CONTACTS_FAILED
}

export interface IAddContactsAction {
  type: ContactsActionTypes.ADD_CONTACTS
  payload: IContactsItem
}

export interface IAddingContactsAction {
  type: ContactsActionTypes.ADDING_CONTACTS
}

export interface IAddedContactsAction {
  type: ContactsActionTypes.ADDED_CONTACTS
  payload: {
    contacts: IpaginatedContacts
  }
}

export interface IAddingContactsFailedAction {
  type: ContactsActionTypes.ADDING_CONTACTS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveContactAction {
  type: ContactsActionTypes.REMOVE_CONTACT
  payload: IContactsItem
}

export interface IRemovingContactAction {
  type: ContactsActionTypes.REMOVING_CONTACT
}

export interface IRemovedContactAction {
  type: ContactsActionTypes.REMOVED_CONTACT
}

export interface IRemovingContactFailedAction {
  type: ContactsActionTypes.REMOVING_CONTACT_FAILED
}

export interface ISoftRemoveContactsAction {
  type: ContactsActionTypes.SOFT_REMOVE_CONTACTS
  payload: IContactsItem
}

export interface ISoftRemovingContactsAction {
  type: ContactsActionTypes.SOFT_REMOVING_CONTACTS
}

export interface ISoftRemovedContactsAction {
  type: ContactsActionTypes.SOFT_REMOVED_CONTACTS
  payload: IContactsItem
}

export interface ISoftRemovingContactsFailedAction {
  type: ContactsActionTypes.SOFT_REMOVING_CONTACTS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditContactsAction {
  type: ContactsActionTypes.EDIT_CONTACTS
  payload: IContactsItem
}

export interface IEditingContactsAction {
  type: ContactsActionTypes.EDITING_CONTACTS
}

export interface IEditedContactsAction {
  type: ContactsActionTypes.EDITED_CONTACTS
  payload: IContactsItem
}

export interface IEditingContactsFailedAction {
  type: ContactsActionTypes.EDITING_CONTACTS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewContactsAction {
  type: ContactsActionTypes.VIEW_CONTACTS
  payload: IContactsItem
}

export interface IViewingContactsAction {
  type: ContactsActionTypes.VIEWING_CONTACTS
}

export interface IViewedContactsAction {
  type: ContactsActionTypes.VIEWED_CONTACTS
  payload: IContactsItem
}

export interface IViewingContactsFailedAction {
  type: ContactsActionTypes.VIEWING_CONTACTS_FAILED
}

export type ContactsAction =
  | ISearchContactsAction
  | ISearchingContactsAction
  | IFoundContactsAction
  | ISearchingContactsFailedAction
  | ILoadContactsAction
  | ILoadingContactsAction
  | ILoadedContactsAction
  | ILoadingContactsFailedAction
  | IAddContactsAction
  | IAddingContactsAction
  | IAddedContactsAction
  | IAddingContactsFailedAction
  | IRemoveContactAction
  | IRemovingContactAction
  | IRemovedContactAction
  | IRemovingContactFailedAction
  | ISoftRemoveContactsAction
  | ISoftRemovingContactsAction
  | ISoftRemovedContactsAction
  | ISoftRemovingContactsFailedAction
  | IEditContactsAction
  | IEditingContactsAction
  | IEditedContactsAction
  | IEditingContactsFailedAction
  | IViewContactsAction
  | IViewingContactsAction
  | IViewedContactsAction
  | IViewingContactsFailedAction
